import { HTTP_TYPES } from '@/lib/enums';
import api from '@/api/api';

const aggregationsRoutes = {
    async postSearchAggregations(payload: any): Promise<any> {
        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_AGGREGATIONS}/statistics/aggregation`,
            payload
        );
    },
    async postExportAggregations(payload: any): Promise<any> {
        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_AGGREGATIONS}/statistics/aggregation`,
            payload,
            undefined,
            'application/json',
            'v1',
            {
                Accept: 'text/csv'
            }
        );
    }
};

export default aggregationsRoutes;
